/* eslint-disable react/prop-types */

import { createContext, useState } from 'react';


export const SideMenuContext = createContext();

export const SideMenuProvider = ({ children }) => {

  const [expandSideMenu, setExpandSideMenu] = useState(false)


  return (
    <SideMenuContext.Provider value={{expandSideMenu, setExpandSideMenu}}>
      {children}
    </SideMenuContext.Provider>
  );
}
